import React, {Fragment} from 'react';

import MUIDataTable from "mui-datatables";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import NumberFormat from 'react-number-format';
import Notification from '../Notifications';
import { PayMethodsApi } from '../../api/paymethods_api';


const options = {
    selectedRows: {
        text: "fila(s) seleccionada",
        delete: "Delete",
        deleteAria: "Eliminar forma de pago"
    },
    downloadOptions: {
        filename: 'Listado formas de pago.csv',
        separator: ','
    },
    textLabels: {
        body: {
            noMatch: "No hay medios de pago registrados",
            toolTip: "Sort",
        },
        pagination: {
            next: "Siguiente pag",
            previous: "Anterior",
            rowsPerPage: "Filas por pagina:",
            displayRows: "de",
        },
        toolbar: {
            search: "Buscar",
            downloadCsv: "Descargar CSV",
            print: "Imprimir",
            viewColumns: "Ver columnas",
            filterTable: "Filtrar tabla",
        },
        selectedRows: {
            text: "fila(s) seleccionadas",
            delete: "Eliminar",
            deleteAria: "Eliminar medio(s) de pago",
        },

    },

}

import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import lightBlue from "@material-ui/core/colors/lightBlue";


const materialTheme = createMuiTheme({
    palette: {
        primary: {
          main: '#ea8b0e',
        },
        secondary: {
          main: '#cea671',
        },
        title: {
          color: 'white',
        },
        background: {
          main: "#cbd0d8"
        }
      },
    typography: {
        fontFamily: "Helvetica",
        fontSize: 20,
        fontWeightLight: 300,
        fontWeightRegula: 400,
        fontWeightMedium: 500,
        h4: {
          fontFamily: "\"Rock Salt\"",
          color: "#393c42",
          fontSize: 20,
        }
      },
   
  });

const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };

const percentageLimit = (val)=> {
    if(val === 0){
        val = 1
    }else if(val >1000){
        val = 1000
    }else if(val < -1000){
        val = -1000
    }
    return val
}

function PercentageFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: percentageLimit(values.value),
                    },
                });
            }}
            decimalScale={2}
            allowNegative={true}
            thousandSeparator={'.'}
            decimalSeparator={','}
            suffix="%"
        />
    );
}


export class PaymentMethodView extends React.Component {

    constructor() {
        super();
        this.state = {
            payMethod: "Debito",
            amount: 0,
            quotes: null,
            cardName: null,
            isLoading: true,
            showMsg: false,
            msgType: 'success', // or 'error'
            msg: null,
            columns: [
                { name: "Id", options: {filter: false, download: false, display: false, viewColumns: false, print: false}},
                {name: "Tipo de Tarjeta"},
                { name: "Nombre" },
                { name: "Pagos" },
                { name: "Interes"},
                ],

            title: "Intereses de medios de pago",
            payMethodsCatalog: []
        }
        
        options['onRowsDelete'] = this.removePayMethod

    }
    removePayMethod = (rowsDeleted) => {
        const deletePayMethodResources = rowsDeleted.data.map((data) => {
            return this.state.payMethodsCatalog[data.dataIndex][0]
        });
        const data = deletePayMethodResources.join(',')
        PayMethodsApi.delete(data)
        .then(response =>{
            this.setState({showMsg: true, msgType: 'success', msg:'Forma de pago eliminada'})
            this.loadCards()
        })
        .catch(response =>{
            console.log(response)
            this.setState({showMsg: true, msgType: 'error', msg:'No se pudo realizar la operacion'})
            
        })
    }
    handleChange = (event) => {
        this.setState({ payMethod: event.target.value });
    }
    setAmount = (e) =>{
        this.setState({amount: parseInt(e.target.value)})
    }
    setCardName = (e) =>{
        this.setState({cardName: e.target.value})
    }
    setQuotes = (e) =>{
        this.setState({quotes:e.target.value})
    }
    handleClose = () => {
        this.setState({showMsg: false})
    }
    componentDidMount = () => {
        this.loadCards()

    }

    loadCards = () =>{
        PayMethodsApi.getList()
        .then(response =>{
            let rows = []
            response.data.results.map(function(payMethod){
                rows.push([payMethod.id, payMethod.card_type, payMethod.name,
                           payMethod.quotes, payMethod.amount])

            })
            this.setState({payMethodsCatalog: rows, isLoading: false})

        })
        .catch(error =>{
            console.log(error)
            this.setState({showMsg: true, msgType: 'error', msg:'No se pudo cargar las tarjetas', isLoading: false})
        })
    }

    
    createCard = () =>{
        
        let data = {'card_type': this.state.payMethod, 'name': this.state.cardName,
                      'quotes': this.state.quotes, "amount": this.state.amount}
        if(this.state.payMethod == "Credito" ){
            if(this.state.cardName == "" || this.state.quotes == 0 || this.state.cardName == null  || this.state.amount < 1){
                this.setState({showMsg: true, msgType: 'error', msg:'Revisar datos'})
                return
            }
        }
        
        if(this.state.payMethod === 'Debito'){
            data.quotes = 'Un Pago'
            data.name = 'Todas'
        }
        PayMethodsApi.send(data)
        .then( response =>{
            this.setState({showMsg: true, msgType: 'success', msg:'Tarjeta creada'})
            this.loadCards()
        })
        .catch(error =>{
            console.log(error)
            this.setState({showMsg: true, msgType: 'error', msg:'Revisar datos'})
            
        })
    
        }
    

    render = () => {
        console.log(this.state.payMethod)
        return (
            <div>
            {this.state.isLoading?
                <div style={{ marginTop: 70 }} className="col-md-6 col-md-offset-5">
                    <CircularProgress
                        size={80}
                        color='primary'
                        thickness={3}
                        style={{ display: 'center' }} />
                </div>:
                <div>
                <MUIDataTable
                title={this.state.title}
                data={this.state.payMethodsCatalog}
                columns={this.state.columns}
                options={options}
            />

                <FormControl component="fieldset">
                    <RadioGroup aria-label="position" name="position" value={this.state.payMethod} onChange={this.handleChange} row>
                        <FormControlLabel
                            value="Debito"
                            control={<Radio color="primary" />}
                            label="Debito"
                            labelPlacement="top"
                        />
                        <FormControlLabel
                            value="Credito"
                            control={<Radio color="primary" />}
                            label="Credito"
                            labelPlacement="top"
                        />

                    </RadioGroup>
                </FormControl>

                <Divider />
                <div className='col-md-10'>
                {this.state.payMethod == "Debito"?<div>
     
                <br/>               
                    <Divider />
                    <div className='col-md-2'>
                    <Typography  style={{ marginLeft: 15, marginTop: 20 }} variant="subtitle1" gutterBottom>
                        Interes:
                    </Typography>
                    </div>
                    <div className='col-md-1'>
                      <TextField
                      label="Porcentaje"
                      value={this.state.amount}
                      onChange={this.setAmount}
                      id="amount"
                      InputProps={{
                          inputComponent: PercentageFormatCustom,
                      }}
                  /></div></div>
                    :<Fragment>
                   <br/> 
                    <Divider />
                    <div className='col-md-3'>
                    <TextField
                      label="Nombre Tarjeta"
                      onInput={toInputUppercase}
                      value={this.state.cardName}
                      placeholder='VISA/MASTERCARD..'
                      onChange={this.setCardName}
                      id="cardname"
                      
                        />
                    </div>
                    <div className='col-md-3'>
                       <TextField
                      label="Cuotas"
                      onInput={toInputUppercase}
                      value={this.state.quotes}
                      placeholder="Un pago/ Hasta 3/ Mas de 3.."
                      onChange={this.setQuotes}
                      id="cuotes"
                    />
                    </div>
                    <div className='col-md-2'>
                    <TextField
                      label="Porcentaje"
                      value={this.state.amount}
                      onChange={this.setAmount}
                      id="amount"
                      InputProps={{
                          inputComponent: PercentageFormatCustom,
                      }}
                  />
                     </div>
                    </Fragment>}
                </div>
                
                <div className='col-md-2 col-md-offset-8'>
                 <Button
                 onClick={this.createCard}
                 variant="contained"
                 color="primary"
                 disabled={false}
             >

                 Aceptar
             </Button>
             </div>
             <Notification
                    open={this.state.showMsg}
                    variant={this.state.msgType}
                    message={this.state.msg}
                    onClose={this.handleClose}
                />
            </div>}
            </div>
        )

    }
}


export default PaymentMethodView;


// WEBPACK FOOTER //
// ./src/components/Billing/PayMethodView.js